export default __webpack_public_path__ + "static/media/badgeG.c78ab70b.png";